<mat-tab-group class="custom-tab-group" color="warn" (focusChange)="onTabFocusChange($event)">
  <mat-tab label="ESTADÍSTICAS" id="tab-estadisticas" class="overflowAuto">
    <div class="container">
        <div class="header">
            <div class="header-content">
              <div class="top-container width100">
                <!--<span style="font-size: 20px; margin-right: 10px;">ESTADÍSTICAS DE CONSUMO</span>-->
                <!--<button mat-button [matMenuTriggerFor]="menu" aria-label="ranking" class="ranking-button" [disabled]="botonRankingInhabilitado">
                  Ranking mensual
                </button>-->
              </div>
              <!--<mat-menu #menu="matMenu" xPosition="before" [overlapTrigger]="true" [hasBackdrop]="true" backdropClass="customize"> 
                <div style="width: 300px;">
                  <mat-list>
                    <mat-list-item *ngFor="let establecimiento of topRankingData; let i = index">
                      <div style="display: flex; flex-direction: row;" 
                      [ngClass]="{
                        'cinco-primeros-style': i < 5,
                        'tres-primeros-style': i < 3,
                        'primero-style': i < 1
                      }">
                        <div style="width: 60%;">
                          {{ establecimiento.name }}
                        </div>
                        <div style="width: 30%; margin-left: 10%;">
                          {{establecimiento.consumoMensual}} L
                        </div>
                      </div>
                    </mat-list-item>
                  </mat-list>
                </div>
              </mat-menu>-->
              <!--<mat-expansion-panel class="ranking-expansion-container" #panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title style="color: white; padding: 20px;">
                    <div style="margin-left: -20px;">
                      Ranking mensual
                    </div>
                    <mat-icon class="custom-icon">{{ panel.expanded ? 'arrow_circle_up' : 'arrow_circle_down' }}</mat-icon>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div style="width: fit-content; overflow: visible;">
                  <mat-list>
                    <mat-list-item *ngFor="let establecimiento of rankingData">
                      {{ establecimiento.name }}  ---  {{establecimiento.consumoMensual}}
                    </mat-list-item>
                  </mat-list>
                </div>
              </mat-expansion-panel>-->
            </div>
            <span class="header-sub-text font155">Aplique diferentes filtros y obtenga estadísticas de consumo.</span>
        </div>
        <div class="body">
            <div class="body-options-container">
              
              <!--FILTROS GUARDADOS-->

              <div class="filtros-container">
                <span class="filtro-header azul">BÚSQUEDAS GUARDADAS<mat-icon>filter_list</mat-icon></span>

                <div class="custom1">
                  <form>
                      <mat-form-field class="width80">
                          <mat-label>-Nombre de la búsqueda-</mat-label>
                          <input type="text"
                                  placeholder="Elige una"
                                  aria-label="Filtros"
                                  matInput
                                  [formControl]="myControl"
                                  [matAutocomplete]="auto">
                          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                  {{ option.name }}
                              </mat-option>
                          </mat-autocomplete>
                          <button *ngIf="myControl.value != ''" matSuffix mat-button aria-label="Clear" (click)="limpiarSeleccion()"
                          class="marginRight10">
                              <mat-icon>close</mat-icon>
                          </button>
                      </mat-form-field>
                  </form>
                  <button mat-stroked-button class="eliminar-btn" color="warn" aria-label="Eliminar búsqueda" 
                  (click)="eliminarBusqueda()" *ngIf="myControl.value !== null && myControl.value !== '' && busquedaSeleccionada()">
                    Eliminar búsqueda
                  </button>
                </div>
              </div>

              <!--FECHA Y HORA-->
                <div class="estadisticas-fecha">
                    <span class="filtro-header">FECHA<mat-icon>date_range</mat-icon></span>

                    <mat-form-field class="fecha-form" color="warn">
                        <mat-label class="amarillo">Elige una fecha</mat-label>
                        <!--[max]="fechaMinima">-->
                        <mat-date-range-input
                          [formGroup]="selectedDateGlobal"
                          [rangePicker]="selectedDatePicker"
                          [max]="fechaMinima">
                          <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                          <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                        </mat-date-range-input>
                        <mat-hint>Día/Mes/Año</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="selectedDatePicker" class="amarillo"></mat-datepicker-toggle>
                        <mat-date-range-picker #selectedDatePicker></mat-date-range-picker>
                    </mat-form-field>

                    <!--<div style="margin-top: 20px;">
                      <mat-chip-listbox aria-label="Seleccion de intervalo">
                        <mat-chip-option (click)="toggleSelection(option)" [selected]="option.selected" *ngFor="let option of intervaloOption"
                        color="warn" style="margin-right: 10px; margin-left: 10px;">
                          {{ option.label }}
                        </mat-chip-option>
                      </mat-chip-listbox>
                    </div>-->
                </div>

                <div class="estadisticas-intervalos">
                  <mat-radio-group [(ngModel)]="opcionSeleccionada">
                    <mat-radio-button value="porHoras" class="marginRight10">¿Mostrar consumo por horas?</mat-radio-button>
                    <mat-radio-button value="porDia" class="marginRight10">¿Mostrar consumo por día?</mat-radio-button>
                    <mat-radio-button value="porSemana" class="marginRight10">¿Mostrar consumo por semana?</mat-radio-button>
                    <mat-radio-button value="porMes" class="marginRight10">¿Mostrar consumo por mes?</mat-radio-button>
                    <mat-radio-button value="porTotal" class="marginRight10">¿Mostrar consumo total?</mat-radio-button>
                  </mat-radio-group>
                </div>

                <!--UBICACION-->
                <div class="estadisticas-globales">

                  <span class="filtro-header marginTop20">UBICACIÓN<mat-icon>location_on</mat-icon></span>

                  <mat-form-field class="elige" color="warn">
                      <mat-label>-País-</mat-label>
                      <mat-select [(ngModel)]="selectedPaises" name="modVer" multiple (selectionChange)="seleccionCambiada()">
                        <mat-checkbox [(ngModel)]="selectAllPaises" (change)="selectAllPaisesChanged()" 
                        style="color:#FBB040" class="marginLeft5">
                          <span class="custom2">Seleccionar todos</span>
                        </mat-checkbox>
                        <mat-option *ngFor="let modVer of paises" [value]="modVer.name">
                          {{modVer.name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>

                  <mat-form-field class="elige marginTop20" color="warn">
                      <mat-label>-Comunidad Autónoma-</mat-label>
                      <mat-select [(ngModel)]="selectedComunidades" name="modVer" multiple (selectionChange)="seleccionCambiada()">
                        <mat-checkbox [(ngModel)]="selectAllComunidades" (change)="selectAllComunidadesChanged()" 
                        style="color:#FBB040" class="marginLeft5">
                          <span class="custom2">Seleccionar todos</span>
                        </mat-checkbox>
                        <mat-option *ngFor="let modVer of comunidades" [value]="modVer.name">
                          {{modVer.name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>

                  <mat-form-field class="elige marginTop20" color="warn">
                      <mat-label>-Provincia-</mat-label>
                      <mat-select [(ngModel)]="selectedProvincias" name="modVer" multiple (selectionChange)="seleccionCambiada()">
                        <mat-checkbox [(ngModel)]="selectAllProvincias" (change)="selectAllProvinciasChanged()" 
                        style="color:#FBB040" class="marginLeft5">
                          <span class="custom2">Seleccionar todos</span>
                        </mat-checkbox>
                        <mat-option *ngFor="let modVer of provincias" [value]="modVer.name">
                          {{modVer.name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>

                  <mat-form-field class="elige marginTop20" color="warn">
                      <mat-label>-Localidad-</mat-label>
                      <mat-select [(ngModel)]="selectedLocalidades" name="modVer" multiple (selectionChange)="seleccionCambiada()">
                        <mat-checkbox [(ngModel)]="selectAllLocalidades" (change)="selectAllLocalidadesChanged()" 
                        style="color:#FBB040" class="marginLeft5">
                          <span class="custom2">Seleccionar todos</span>
                        </mat-checkbox>
                        <mat-option *ngFor="let modVer of localidades" [value]="modVer.id">
                          {{modVer.name}} (C.P: {{modVer.codigoPostal}}, provincia: {{modVer.provincia}})
                        </mat-option>
                      </mat-select>
                  </mat-form-field>

                </div>

                <!--ESTABLECIMIENTOS-->
                  <div class="estadisticas-cliente">

                    <span class="filtro-header">ESTABLECIMIENTOS<mat-icon>store</mat-icon></span>
                    <mat-form-field class="elige" color="warn">
                        <mat-label>-Establecimientos-</mat-label>
                        <mat-select [(ngModel)]="selectedEstablecimiento" name="modVer" multiple>
                          <mat-checkbox [(ngModel)]="selectAllEstablecimientos" (change)="selectAllEstablecimientosChanged()" 
                          style="color:#FBB040" class="marginLeft5">
                            <span class="custom2">Seleccionar todos</span>
                          </mat-checkbox>
                          <mat-option *ngFor="let modVer of establecimientosCopia" [value]="modVer.value">
                            {{modVer.name}}
                          </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <span class="filtro-header">TIPO DE CERVEZA<img class="material-icons" src="assets/images/icons8-beer-96-Amarillo.png" height="23"/></span>
                    <mat-form-field class="elige" color="warn">
                        <mat-label>-Tipos de cerveza-</mat-label>
                        <mat-select [(ngModel)]="selectedCervezas" name="est" multiple (selectionChange)="seleccionCambiada()">
                          <mat-checkbox [(ngModel)]="selectAllCervezas" (change)="selectAllCervezasChanged()" 
                          style="color:#FBB040" class="marginLeft5">
                            <span class="custom2">Seleccionar todos</span>
                          </mat-checkbox>
                          <mat-option *ngFor="let est of cervezasEstadisticas" [value]="est.value">
                            {{est.name}}
                          </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <span class="filtro-header">DELEGACIÓN</span>

                    <mat-form-field class="elige" color="warn">
                        <mat-label>-Elige las delegaciones-</mat-label>
                        <mat-select color="warn" [(ngModel)]="selectedEstablecimiento" name="modVer" multiple disabled>
                          <mat-option *ngFor="let modVer of establecimientos" [value]="modVer.value">
                            {{modVer.name}}
                          </mat-option>
                        </mat-select>
                    </mat-form-field>

                  </div>
            </div>

            <div class="guardar-filtros-container">
              <mat-form-field class="custom3" appearance="outline">
                <input matInput [(ngModel)]="nombreFiltro" placeholder="Nombre de la búsqueda">
              </mat-form-field>
              <button mat-button class="guardar-btn custom4" (click)="guardarFiltro()" [disabled]="waitAfterSave">
                Guardar búsqueda
                <mat-icon class="iconoGuardarBusqueda" iconPositionEnd>bookmark</mat-icon>
              </button>
            </div>

            <!--APLICAR FILTROS Y RESULTADO-->
            <div class="tip">
              <p>Seleccionar una ubicación no excluye a otra. Por ejemplo, si seleccionas las provincias de Lugo y A Coruña aparecerán disponibles 
                para ser seleccionados los establecimientos de las dos provincias. Lo mismo sucede con los tipos de cerveza.
                <br><br>
                Para mostrar los resultados es necesario seleccionar una ubicación o un establecimiento.
                La ubicación solo aparecerá en la tabla de resultados si no se selecciona ningún establecimiento.
              </p>
            </div>

            <div class="body-botones">
              <button mat-raised-button class="aplicar-btn" (click)="ejecutarFiltros()">APLICAR FILTROS</button>
            </div>

            <ng-container *ngIf="errorMessage !==''">
              <div class="error-container">
                <p class="info-text">{{errorMessage}}</p>
              </div>
            </ng-container>

            <ng-container *ngIf="mostrarTabla == true && mostrarTabla1 == true && sinDatos">
              <div class="info-container">
                <p class="info-text">No se han encontrado datos con los filtros seleccionados</p>
              </div>
            </ng-container>

            <ng-container *ngIf="mostrarTabla == true && mostrarTabla1 == true && !sinDatos">
              <div class="info-container">
                <p class="info-text">A continuación se muestra el <b class="negrita-text">{{intervalosFecha}}</b> desde el: 
                  <b class="negrita-text">{{startGlobal}}</b> hasta el: <b class="negrita-text">{{endGlobal}}</b><b *ngIf="existeSelected(selectedEstablecimiento)">
                    <b *ngIf="!todosIguales"> por<b class="negrita-text"> establecimientos</b></b>
                    <b *ngIf="todosIguales"> en el establecimiento<b class="negrita-text"> {{primerNombreEstablecimiento}}</b></b>
                  </b>
                  <!--<b class="negrita-text" *ngFor="let establecimiento of selectedEstablecimiento">-- {{devolverNombreEstablecimientos(establecimiento)}} </b>-->
                  <!--<b *ngFor="let establecimiento of selectedEstablecimiento">
                    --- <b class="underline-text">{{devolverNombreEstablecimientos(establecimiento)}}</b>
                  </b>-->
                  <b class="info-text" *ngIf="!existeSelected(selectedEstablecimiento) && selectedLocalidades.length !== 0"> 
                    <b *ngIf="!todosIguales"> por<b class="negrita-text"> localidades</b></b>
                    <b *ngIf="todosIguales"> en la localidad de<b class="negrita-text"> {{primerNombreEstablecimiento}}</b></b>
                  </b>
                  <b class="info-text" *ngIf="!existeSelected(selectedEstablecimiento) && selectedLocalidades.length === 0 && existeSelected2(selectedProvincias)">
                    <b *ngIf="!todosIguales"> por<b class="negrita-text"> provincias</b></b>
                    <b *ngIf="todosIguales"> en la provincia de<b class="negrita-text"> {{primerNombreEstablecimiento}}</b></b>
                  </b>
                  <b class="info-text" *ngIf="!existeSelected(selectedEstablecimiento) && selectedLocalidades.length === 0 && !existeSelected2(selectedProvincias) && 
                  existeSelected2(selectedComunidades)">
                  <b *ngIf="!todosIguales"> por<b class="negrita-text"> comunidades autónomas</b></b>
                  <b *ngIf="todosIguales"> en la comunidad autónoma de<b class="negrita-text"> {{primerNombreEstablecimiento}}</b></b>
                  </b>
                  <b class="info-text" *ngIf="!existeSelected(selectedEstablecimiento) && selectedLocalidades.length === 0 && !existeSelected2(selectedProvincias) && 
                  !existeSelected2(selectedComunidades) && existeSelected2(selectedPaises)">
                  <b *ngIf="!todosIguales"> por<b class="negrita-text"> paises</b></b>
                  <b *ngIf="todosIguales"> en el país<b class="negrita-text"> {{primerNombreEstablecimiento}}</b></b>
                  </b>
                  <b class="info-text" *ngIf="existeSelected(selectedCervezas)"> y por tipo de cerveza: --
                    <b *ngFor="let cerveza of selectedCervezas">
                      <b class="negrita-text"> {{devolverNombreDeCerveza(cerveza)}}</b> --
                    </b>
                  </b>
                </p>
                <!--<p class="info-text" *ngIf="existeSelected2(selectedPaises) || existeSelected2(selectedComunidades) || existeSelected2(selectedProvincias)
                || existeSelected2(selectedLocalidades)">Dichos establecimientos cumplen los filtros de estar ubicados en
                  <b *ngIf="existeSelected2(selectedPaises)"> el país: </b>
                  <b *ngFor="let pais of selectedPaises">
                      -- <b class="negrita-text"> {{pais}}</b>
                  </b>
                  <b *ngIf="existeSelected2(selectedComunidades)"> la comunidad: </b>
                  <b *ngFor="let comunidad of selectedComunidades">
                    -- <b class="negrita-text"> {{comunidad}}</b>
                  </b>
                  <b *ngIf="existeSelected2(selectedProvincias)"> la provincia: </b>
                  <b *ngFor="let provincia of selectedProvincias">
                    -- <b class="negrita-text"> {{provincia}}</b>
                  </b>
                  <b *ngIf="existeSelected2(selectedLocalidades)"> la localidad: </b>
                  <b *ngFor="let localidad of selectedLocalidades">
                    -- <b class="negrita-text"> {{localidad}}</b>
                  </b>
                  .
                </p>-->
              </div>
            </ng-container>

            <ng-container *ngIf="errorMessage =='' && cargarDatos == undefined">
              <div class="cargando-container">
                Cargando datos...
                <img src="assets/images/canalejas/loading.gif" 
                alt="Cargando..."
                class="custom5"/>
              </div>
            </ng-container>

            <ng-container *ngIf="errorMessage =='' && mostrarTabla == true && mostrarTabla1 == true && !sinDatos">
              <div class="top-container-resultado">
                  <mat-form-field class="form-search">
                    <mat-label class="negro">Filtrar</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                  </mat-form-field>
                  <button mat-flat-button (click)="exportToExcel()" class="excel-btn">
                    <mat-icon class="custom-icon">file_download</mat-icon>
                    Exportar a Excel
                  </button>
              </div>

              <div class="tabla padding20" #TABLE>
                  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="carbs" matSortDirection="asc" #table>
                    <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="verticalAlignMiddle"> 
                        <ng-container *ngIf="column === 'nombreEstablecimiento' && selectedEstablecimiento.length !== 0">
                          Establecimiento
                        </ng-container> 
                        <ng-container *ngIf="column === 'nombreEstablecimiento' && selectedEstablecimiento.length === 0">
                          {{ubicacionSeleccionada}}
                        </ng-container> 
                        <ng-container *ngIf="column === 'date1'">
                          Fecha (Año/Mes/Día)
                        </ng-container> 
                        <ng-container *ngIf="column === 'date2'">
                          Fecha (Año/Semana)
                        </ng-container> 
                        <ng-container *ngIf="column === 'date3'">
                          Fecha (Año/Mes)
                        </ng-container> 
                        <ng-container *ngIf="column === 'porHoras'">
                          Hora (24h)
                        </ng-container> 
                        <ng-container *ngIf="column === 'consumoTotal'">
                          Consumo Total (Litros)
                        </ng-container> 
                        <!--<ng-container *ngIf="column === 'estrellaGaliciaEspecial'">
                          Estrella Galicia Especial
                        </ng-container> 
                        <ng-container *ngIf="column === 'estrellaGalicia1906'">
                          Estrella Galicia 1906
                        </ng-container> 
                        <ng-container *ngIf="column === 'alouminha'">
                          Aloumiña
                        </ng-container> -->
                        <ng-container *ngFor="let cerveza of cervezasEstadisticas">
                          <ng-container *ngIf="column === 'cerveza' + cerveza.value">
                            {{ cerveza.name }}
                          </ng-container>
                        </ng-container>
                      </th>
                      <td mat-cell *matCellDef="let element" class="login-cell" 
                      [ngClass]="{
                        'consumo-cell': displayedColumns.includes(column) &&
                                        (column === 'consumoTotal' || isCervezaColumn(column)),
                        'bold-cell': column === 'nombreEstablecimiento'
                      }">
                      {{ (column === 'consumoTotal' || column.startsWith('cerveza')) ? soloDosDecimalesConComa(getCellValue(column, element)) : getCellValue(column, element) }} 
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>

                  <!--{{element[column]}}-->
                  <!--[ngClass]="{
                    'consumo-cell': column === 'consumoTotal' || column === 'estrellaGaliciaEspecial' || column === 'estrellaGalicia1906' || column === 'alouminha',
                    'bold-cell': column === 'nombreEstablecimiento'
                  }"> -->
                  <mat-paginator 
                      [pageSizeOptions]= "[25,50,100]" 
                      showFirstLastButtons 
                      aria-label="Elige una página"
                      class="custom6">
                  </mat-paginator>
              </div>
          </ng-container>

            <!--<ng-container *ngIf="errorMessage ==='' && mostrarTabla == true">
              <div class="tabla-resultados">
                  <div class="top-container">
                      <mat-form-field>
                          <mat-label>Filtrar</mat-label>
                          <mat-icon matPrefix>search</mat-icon>
                          <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
                      </mat-form-field>
                  </div>
          
                  <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc">
          
                      <ng-container matColumnDef="establecimiento">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                          <td mat-cell *matCellDef="let element" class="cell"> {{establecimiento}} </td>
                      </ng-container>
          
                      <ng-container matColumnDef="dev_reference">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Dispositivo </th>
                          <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_reference}} </td>
                      </ng-container>
                  
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
          
                  <mat-paginator 
                      [pageSizeOptions]="pageSizeOptions" 
                      showFirstLastButtons 
                      aria-label="Elige una página"
                      style="margin-top: 25px; margin-bottom: 10px;">
                  </mat-paginator>
              </div>
          </ng-container>-->
        </div>
    </div>
  </mat-tab>

  <!--TAB GRÁFICAS-->
  <!--*ngIf="rankingInfoConseguida && rankingCervezasInfoConseguida && mediaCervezasConseguida"-->
  <mat-tab label="GRÁFICAS" id="tab-graficas" *ngIf="rankingInfoConseguida && rankingCervezasInfoConseguida && mediaCervezasConseguida && diarioCervezasConseguida && provinciasConseguido" 
  class="overflowAuto">
    <div class="container">
      <div class="header">
          <div class="header-content">
            <div class="top-container width100">
              <!--<span style="font-size: 20px; margin-right: 10px;">ESTADÍSTICAS GRÁFICAS</span>-->
            </div>
          </div>
          <span class="header-sub-text font155">Gráficas sobre los diferentes tipos de consumo.</span>
      </div>
      <div class="body">
          <div class="body-options-container">
              <div class="tabla-ranking" *ngIf="rakingEstablecimientosCambiadaCargarda">
                <h6 class="titulo-nombre-ranking">Top 10 establecimientos con más consumo</h6>

                <div class="padding10">
                  <mat-form-field class="fecha-form-grafica" color="warn">
                    <mat-label class="amarillo">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateTopEstablecimientos"
                        [rangePicker]="selectedDatePickerTopEstablecimientos"
                        [max]="fechaMinima">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                        <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerTopEstablecimientos" class="amarillo"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePickerTopEstablecimientos>
                      <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>Cancelar</button>
                        <button mat-raised-button (click)="cambiarFechaRankingEstablecimientos()" class="cambiar-fecha-btn" matDateRangePickerApply>
                          Modificar fecha
                        </button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                </div>

                <div class="rankingConsumoTotal-body" *ngIf="rankingEstablecimientosDatos">
                  <div class="rankingConsumoTotal-container">
                    <div *ngFor="let cerveza of consumoTotalesTotalesPorCerveza" class="rankingConsumoTotal">
                      <p class="lineHeight"><span class="custom7">{{ cerveza.type }}</span></p>
                      <p class="custom8">Consumo Total: <span class="custom9">{{ soloDosDecimalesConComa(cerveza.consumo) }} L</span></p>
                    </div>
                  </div>  
                </div>

                <div class="g-Ranking height400" *ngIf="rankingEstablecimientosDatos">
                    <canvas id="Ranking"></canvas>
                    <button mat-flat-button class="resetZoomButton" (click)="resetZoomRanking()">
                      <mat-icon class="restoreIcon">restore</mat-icon> Zoom
                    </button>
                </div>

                <div *ngIf="!rankingEstablecimientosDatos" class="custom10">
                  <span>No hay datos disponibles en las fechas seleccionadas</span>
                  <div class="custom11">
                    <img src="assets/images/icons8-not-found-96.png">
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!rakingEstablecimientosCambiadaCargarda">
                <div class="tabla-ranking">
                  <h6 class="titulo-nombre-ranking">Top 10 establecimientos con más consumo</h6>
                  <span>Cargando datos...</span>
                  <div>
                    <img src="assets/images/canalejas/loading.gif" 
                    alt="Cargando..."
                    class="custom5"/>
                  </div>
                </div>
              </ng-container>

              <mat-divider class="custom12"></mat-divider>   

              <div class="tabla-ranking-cervezas marginBottom120" *ngIf="semanalEspanaCambiadaCargada">
                <h6 class="titulo-nombre-ranking">Tendencia de consumo semanalmente en España</h6>

                <div class="padding10">
                  <!--[dateFilter]="myFilter"-->
                  <mat-form-field class="fecha-form-grafica marginRight20" color="warn">
                    <mat-label class="amarillo">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateCervezasSemanal"
                        [rangePicker]="selectedDatePickerCervezasSemanal"
                        [max]="fechaMinima">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                        <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerCervezasSemanal" class="amarillo"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePickerCervezasSemanal>
                      <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>Cancelar</button>
                        <button mat-raised-button (click)="cambiarFechaCervezasSemanal()" class="cambiar-fecha-btn" matDateRangePickerApply>
                          Modificar fecha
                        </button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>

                  <button mat-flat-button class="resetZoomButton2" (click)="resetZoomSemanal()">
                    <mat-icon class="restoreIcon">restore</mat-icon> Zoom
                  </button>
                </div>
  
                <div class="c-Ranking" *ngIf="semanalDatos">
                    <canvas id="rankingCervezas"></canvas>
                </div>

                <div *ngIf="!semanalDatos" class="custom10">
                  <span>No hay datos disponibles en las fechas seleccionadas</span>
                  <div class="custom11">
                    <img src="assets/images/icons8-not-found-96.png">
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!semanalEspanaCambiadaCargada">
                <div class="tabla-ranking-cervezas">
                  <h6 class="titulo-nombre-ranking">Tendencia de consumo semanalmente en España</h6>
                  <span>Cargando datos...</span>
                  <div>
                    <img src="assets/images/canalejas/loading.gif" 
                    alt="Cargando..."
                    class="custom5"/>
                  </div>
                </div>
              </ng-container>

              <mat-divider class="custom12"></mat-divider>   

              <div class="custom13" *ngIf="mediaHorasCambiadaCargada">
                <div class="tabla-media-horas">
                  <h6 class="titulo-nombre-ranking">Media de consumo por horas en España</h6>

                  <div class="custom14">
                    <mat-form-field class="fecha-form-grafica width90" color="warn">
                      <mat-label class="amarillo">Elige una fecha</mat-label>
                      <mat-date-range-input
                          [formGroup]="selectedDateMediaHoras"
                          [rangePicker]="selectedDatePickerMediaHoras"
                          [max]="fechaMinima">
                          <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                          <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                      </mat-date-range-input>
                      <mat-hint>Día/Mes/Año</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerMediaHoras" class="amarillo"></mat-datepicker-toggle>
                      <mat-date-range-picker #selectedDatePickerMediaHoras>
                        <mat-date-range-picker-actions>
                          <button mat-button matDateRangePickerCancel>Cancel</button>
                          <button mat-raised-button (click)="cambiarFechaMediaHoras()" class="cambiar-fecha-btn" matDateRangePickerApply>
                            Modificar fecha
                          </button>
                        </mat-date-range-picker-actions>
                      </mat-date-range-picker>
                    </mat-form-field>
  
                  </div>
                  <canvas *ngIf="mediaHorasDatos" id="mediaHoras"></canvas>

                  <div *ngIf="!mediaHorasDatos" class="custom10">
                    <span>No hay datos disponibles en las fechas seleccionadas</span>
                    <div class="custom11">
                      <img src="assets/images/icons8-not-found-96.png">
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!mediaHorasCambiadaCargada">
                <div class="tabla-media-horas">
                  <h6 class="titulo-nombre-ranking">Media de consumo por horas en España</h6>
                  <span>Cargando datos...</span>
                  <div>
                    <img src="assets/images/canalejas/loading.gif" 
                    alt="Cargando..."
                    class="custom5"/>
                  </div>
                </div>
              </ng-container>

              <mat-divider class="custom12"></mat-divider>   

              <div class="tabla-ranking-cervezas marginBottom120" *ngIf="diarioCambiadaCargada">
                <h6 class="titulo-nombre-ranking">Consumo diario en España</h6>

                <div class="padding10">
                  <mat-form-field class="fecha-form-grafica marginRight20" color="warn">
                    <mat-label class="amarillo">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateDiario"
                        [rangePicker]="selectedDatePickerDiario"
                        [max]="fechaMinima">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                        <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerDiario" class="amarillo"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePickerDiario>
                      <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>Cancelar</button>
                        <button mat-raised-button (click)="cambiarFechaDiario()" class="cambiar-fecha-btn" matDateRangePickerApply>
                          Modificar fecha
                        </button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>

                  <button mat-flat-button class="resetZoomButton2" (click)="resetZoomDiario()">
                    <mat-icon class="restoreIcon">restore</mat-icon> Zoom
                  </button>
                </div>

                <div class="cs-Ranking" *ngIf="diarioDatos">
                    <canvas id="cervezasDiario"></canvas>
                </div>

                <div *ngIf="!diarioDatos" class="marginTop55">
                  <span>No hay datos disponibles en las fechas seleccionadas</span>
                  <div class="custom11">
                    <img src="assets/images/icons8-not-found-96.png">
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!diarioCambiadaCargada">
                <div class="tabla-ranking-cervezas">
                  <h6 class="titulo-nombre-ranking">Consumo diario en España</h6>
                  <span>Cargando datos...</span>
                  <div>
                    <img src="assets/images/canalejas/loading.gif" 
                    alt="Cargando..."
                    class="custom5"/>
                  </div>
                </div>
              </ng-container>

              <mat-divider class="custom12"></mat-divider> 

              <div class="tabla-ranking-cervezas marginBottom200" *ngIf="provinciasCambiadaCargada">
                <h6 class="titulo-nombre-ranking">Consumo medio por establecimiento en cada provincia</h6>

                <div class="padding10">
                  <mat-form-field class="fecha-form-grafica" color="warn">
                    <mat-label class="amarillo">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateMediaEstProvincia"
                        [rangePicker]="selectedDatePickerMediaEstProvincia"
                        [max]="fechaMinima">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                        <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerMediaEstProvincia" class="amarillo"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePickerMediaEstProvincia>
                      <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>Cancelar</button>
                        <button mat-raised-button (click)="cambiarFechaMediaEstProvincia()" class="cambiar-fecha-btn" matDateRangePickerApply>
                          Modificar fecha
                        </button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                </div>

                <div class="pc-Ranking" *ngIf="provinciasDatos">
                    <canvas id="provinciasConsumo"></canvas>
                    <button mat-flat-button class="resetZoomButton3" (click)="resetZoomProvincia()">
                      <mat-icon class="restoreIcon">restore</mat-icon> Zoom
                    </button>
                </div>
                
                <div *ngIf="!provinciasDatos" class="marginTop55">
                  <span>No hay datos disponibles en las fechas seleccionadas</span>
                  <div class="custom11">
                    <img src="assets/images/icons8-not-found-96.png">
                  </div>
                </div>
              </div>

              <ng-container *ngIf="!provinciasCambiadaCargada">
                <div class="tabla-ranking-cervezas">
                  <h6 class="titulo-nombre-ranking">Consumo medio por establecimiento en cada provincia</h6>
                  <span>Cargando datos...</span>
                  <div>
                    <img src="assets/images/canalejas/loading.gif" 
                    alt="Cargando..."
                    class="custom5"/>
                  </div>
                </div>
              </ng-container>
          </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
<div class="footer"></div>

